import { throwError } from 'tg-commons'
import type { AbstractMap } from 'tg-map-core'
import { inject, onBeforeUnmount, onMounted, type Ref } from 'vue'
import { useComponentName } from '../utils/hooks'
import { MIXIN_HOOK_CREATE, MIXIN_HOOK_DESTROY, MIXIN_MAP_NAME } from './map-mixin'

/** 作为Vue3下, `MapMixin`的替代 */
export function useTgMapInner<MAP extends AbstractMap = AbstractMap>() {
  const mapRef = inject<Ref<MAP | undefined>>(MIXIN_MAP_NAME)
  let onCreate: VoidFunction | undefined
  let onDestroy: VoidFunction | undefined
  if (mapRef == null) throwError(`<${useComponentName() || 'unknown'}>必须作为<tg-map>的子代组件`)

  return {
    mapRef,
    /** 读取map对象, 只要放在<tg-map>里面的组件(除#overlay插槽外)都能够立即读取到map对象 */
    get map() {
      return mapRef.value ?? throwError('map尚未初始化')
    },
    /** 地图元素创建回调 */
    [MIXIN_HOOK_CREATE](hook: VoidFunction) {
      onMounted(hook)
      if (onCreate) throwError(`${MIXIN_HOOK_CREATE}只能调用一次`)
      onCreate = hook
    },
    /** 地图元素销毁回调 */
    [MIXIN_HOOK_DESTROY](hook: VoidFunction) {
      onBeforeUnmount(hook)
      if (onDestroy) throwError(`${MIXIN_HOOK_DESTROY}只能调用一次`)
      onDestroy = hook
    },
    /** 重新创建地图元素 */
    recreate() {
      onDestroy?.()
      onCreate?.()
    },
  }
}
